import { render, staticRenderFns } from "./simple-checkboxes.vue?vue&type=template&id=3733b92d&scoped=true&"
import script from "./simple-checkboxes.vue?vue&type=script&lang=js&"
export * from "./simple-checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./simple-checkboxes.vue?vue&type=style&index=0&id=3733b92d&prod&scoped=true&lang=css&"
import style1 from "./simple-checkboxes.vue?vue&type=style&index=1&id=3733b92d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733b92d",
  null
  
)

export default component.exports